import Cleave from 'cleave.js';
import $ from 'jquery';
import inject from '@rover/utilities/injector';
import 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

export function initIntlTelInput(inputEl, utilsLoadedCallback) {
  const $intlTelInput = inputEl ? $(inputEl) : $('.js-intl-tel-input');
  $intlTelInput.each(function() {
    // hack: for django form to make sure the correct value is sent to django b/c we cannot call js using
    // traditional post. This will not be an issue if the flow use ajax
    const name = $(this).attr('name');
    $(this).attr('name', '');
    // the utils script will be load lazily. Temp solution until we get better phone number input component
    $(this)
      .intlTelInput({
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.15/js/utils.js',
        hiddenInput: name,
        autoPlaceholder: 'off',
        preferredCountries: ['us', 'ca', 'gb'],
        initialCountry: 'auto',
        geoIpLookup: callback => {
          callback(inject('Rover.context.countryCode', 'US'));
        },
      })
      .done(() => {
        if (utilsLoadedCallback) {
          utilsLoadedCallback($(this));
        }
      });
    $(this).on('countrychange', (e, countryData) => {
      if (typeof window.intlTelInputUtils === 'undefined') return;
      const newNumber = window.intlTelInputUtils.formatNumber(
        $(this).val(),
        countryData.iso2,
        window.intlTelInputUtils.numberFormat.INTERNATIONAL
      );
      $(this).intlTelInput('setNumber', newNumber);
    });
  });
  return $intlTelInput;
}

export function updateCleaveForInputs() {
  // For each of the input, initialize cleave. Cleave gets destroyed and recreated when user change country since
  // we only use cleave for US
  const cleave = $(this).data('cleave');
  if (cleave) {
    cleave.destroy();
  }
  if (['us', 'ca'].includes($(this).intlTelInput('getSelectedCountryData').iso2)) {
    // hack: strip out +1 otherwise cleave will keep adding 1 in the beginning
    const value = $(this).val() || '';
    if (value.startsWith('+1')) {
      $(this).val(value.substring(2));
    }
    $(this).data(
      'cleave',
      new Cleave(this, {
        blocks: [3, 3, 4],
        delimiter: '-',
        numericOnly: true,
      })
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/intl_tel_input.js